
function newRouteItem (route, title, subLinks) {
  return {
    route: route,
    title: title,
    subLinks: subLinks
  };
}

export const navMixin = {
  data () {
    return {
      routes: {
        Home: newRouteItem('Home', 'Home', {}),
        Services: newRouteItem('Services', 'Services', {
          Services: newRouteItem('Services', 'All services', {}),
          ConsumerDebt: newRouteItem('ConsumerDebt', 'Consumer debt', {}),
          CommercialDebt: newRouteItem('CommercialDebt', 'Commercial debt', {}),
          OnlineTools: newRouteItem('OnlineTools', 'Online tools', {}),
          Pricing: newRouteItem('Pricing', 'Pricing', {})
        }),
        CustomerSite: newRouteItem('CustomerSite', 'Customer site', {}),
        Careers: newRouteItem('Careers', 'Careers', {}),
        AboutUs: newRouteItem('AboutUs', 'About us', {}),
        FAQ: newRouteItem('FAQ', 'FAQ', {}),
        ContactUs: newRouteItem('ContactUs', 'Contact us', {})
      }
    };
  },
  computed: {
    activeRoute () {
      return this.$route.name;
    }
  },
  methods: {
    routesToArray (routesObj) {
      return Object.entries(routesObj).map((key) => {
        const item = key[1];
        return {
          ...item,
          subLinks: Object.keys(item.subLinks).length > 0 ? this.routesToArray(item.subLinks) : []
        };
      });
    },
    getNavIcon (navRoute) {
      switch (navRoute) {
        case 'Home':
          return 'fas fa-home-lg-alt';
        case 'MyAccount':
          return 'fas fa-briefcase';
        case 'Services':
          return 'fas fa-file-lines';
        case 'Careers':
          return 'fas fa-briefcase';
        case 'CustomerSite':
          return 'fas fa-globe';  
        case 'AboutUs':
          return 'fas fa-user-group';
        case 'ContactUs':
          return 'fas fa-comment-alt';
        default:
          return 'fas fa-hashtag';
      }
    }
  }
}
